import { useEffect, useState } from 'react'
import { generateUuid } from '@shared/lib'
import { useCyberStore } from '@entities/tsp'

export const useRequestId = () => {
  const [id, setId] = useState<string>(generateUuid())

  const { setRequestID } = useCyberStore()

  useEffect(() => {
    setRequestID(id)
  }, [id, setRequestID])

  return [id, setId] as const
}
